import { queryClient } from "@/lib/data/react-query/client";
import { queryKeys } from "@/lib/data/static/query-keys";
import { VITE_AWS_USER_POOL_CLIENT_ID } from "@/lib/data/static/importEnv";
import type { APIResponse, User } from "@/lib/types";

export const getSearchActor = () =>
  localStorage.getItem(
    `CognitoIdentityServiceProvider.${VITE_AWS_USER_POOL_CLIENT_ID}.LastAuthUser`,
  );

export const getSearchScope = () => {
  const actor = getSearchActor();
  const user = queryClient.getQueryData<APIResponse<User>>([
    queryKeys.currentUser,
    actor,
  ])?.data;
  return {
    actor,
    userId: user?.id,
    firmId: user?.firm.id,
    owner: user?.owner,
    grants: user?.effectiveGrants,
  };
};

export const keepPreviousSearchData = <T>(
  previousData: T | undefined,
  previousQuery?: { queryKey: readonly unknown[] },
): T | undefined => {
  const previousScope = previousQuery?.queryKey.find(
    (part) => part !== null && typeof part === "object" && "actor" in part,
  );
  return previousScope &&
    JSON.stringify(previousScope) === JSON.stringify(getSearchScope())
    ? previousData
    : undefined;
};
